import apiClient from '../apiClient';
import { PUT_SERVICE_PRICE_URL } from '../apiUrl';

const putServicePrice = (type, id, data) => {
  return apiClient.put(PUT_SERVICE_PRICE_URL(type, id), data);
};

export default putServicePrice;
